<div class="context-menu">
  <div class="icons-top">
    @if (!isActive()) {
      <orbit-fa-icon
        id="collapse-button"
        class="sidebar-icon-only"
        [iconName]="getCollapseIcon()"
        (click)="collapseHandler($event)"
        role="button"
        tabindex="1"
        data-testid="btn-conversation-sidebar-collapse" />
      @if (isCollapsed()) {
        <div class="collapsed-text" data-testid="conversation-sidebar-label">{{ label() }}</div>
        @if (notifications() > 0 || dot()) {
          <orbit-notification [amount]="notifications()" data-testid="conversation-sidebar-notification" />
        }
      }
    } @else {
      @if (isCloseable()) {
        <div
          class="sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Close }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Close, $event)"
          role="button"
          [title]="'SHARED.CONVERSATION_SIDEBAR.CLOSE_TITLE' | translate"
          tabindex="1"
          data-testid="btn-conversation-sidebar-close">
          <orbit-fa-icon class="sidebar-icon-only-x" [iconName]="xMarkIcon" />
        </div>
      }
      @if (!isConversationArchived()) {
        <div
          class="sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Notify }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Notify, $event)"
          role="button"
          [title]="'SHARED.CONVERSATION_SIDEBAR.NOTIFY_TITLE' | translate"
          tabindex="2"
          data-testid="btn-conversation-sidebar-notify">
          <orbit-fa-icon [iconName]="bell" />
        </div>
      }
      <div
        class="sidebar-icon-only-wrapper"
        [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Participants }"
        (click)="sidebarClicked(SidebarButtonTypeEnum.Participants, $event)"
        role="button"
        [title]="'SHARED.CONVERSATION_SIDEBAR.SHOW_PARTICIPANTS' | translate"
        tabindex="3"
        data-testid="btn-conversation-sidebar-participants">
        <orbit-fa-icon [iconName]="userGroupIcon" />
      </div>
      <div
        class="sidebar-icon-only-wrapper"
        [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Share }"
        (click)="sidebarClicked(SidebarButtonTypeEnum.Share, $event)"
        role="button"
        [title]="'SHARED.CONVERSATION_SIDEBAR.LINK_TITLE' | translate"
        tabindex="5"
        data-testid="btn-conversation-sidebar-share">
        <orbit-fa-icon class="sidebar-icon-share" [iconName]="linkIcon" />
      </div>
      @if (!isConversationArchived()) {
        <div
          class="sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Archive }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Archive, $event)"
          role="button"
          [title]="'SHARED.CONVERSATION_SIDEBAR.ARCHIVE' | translate"
          tabindex="6"
          data-testid="btn-conversation-sidebar-archive">
          <orbit-fa-icon class="sidebar-icon-archive" [iconName]="archiveIcon" />
        </div>
      } @else {
        <div
          class="sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Unarchive }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Unarchive, $event)"
          role="button"
          [title]="'SHARED.CONVERSATION_SIDEBAR.UNARCHIVE' | translate"
          tabindex="6"
          data-testid="btn-conversation-sidebar-unarchive">
          <orbit-fa-icon class="sidebar-icon-archive" [iconName]="unarchiveIcon" />
        </div>
      }
      <div
        class="sidebar-icon-only-wrapper"
        [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Flag }"
        role="button"
        (click)="sidebarClicked(SidebarButtonTypeEnum.Flag, $event)"
        [title]="'SHARED.CONVERSATION_SIDEBAR.FLAG' | translate"
        tabindex="7"
        data-testid="btn-conversation-sidebar-flag">
        @if (selectedFlagColor()) {
          <orbit-fa-icon
            class="flag"
            [ngClass]="'flag-' + selectedFlagColor()"
            [iconName]="filledFlagIcon" />
        } @else {
          <orbit-fa-icon [iconName]="emptyFlag" />
        }
      </div>
      @if (!isConversationArchived()) {
        @if (isConversationLocked()) {
          <div
            class="sidebar-icon-only-wrapper"
            (click)="sidebarClicked(SidebarButtonTypeEnum.Unlock, $event)"
            role="button"
            [title]="'SHARED.CONVERSATION_SIDEBAR.UNLOCK' | translate"
            tabindex="8"
            data-testid="btn-conversation-sidebar-unlock">
            <orbit-fa-icon class="sidebar-icon-archive" [iconName]="unlock" />
          </div>
        } @else {
          <div
            class="sidebar-icon-only-wrapper"
            (click)="sidebarClicked(SidebarButtonTypeEnum.Lock, $event)"
            role="button"
            [title]="'SHARED.CONVERSATION_SIDEBAR.LOCK' | translate"
            tabindex="8"
            data-testid="btn-conversation-sidebar-lock">
            <orbit-fa-icon class="sidebar-icon-archive" [iconName]="lockIcon" />
          </div>
        }
      }
      <!-- <div
        class="sidebar-icon-only-wrapper"
        (click)="this.buttonClick.emit(SidebarButtonTypeEnum.More)"
        role="button"
        tabindex="2">
        <orbit-fa-icon class="sidebar-icon-only-ellipsis" [iconName]="ellipsisIcon" />
      </div>
      <div
        class="sidebar-icon-only-wrapper"
        (click)="this.buttonClick.emit(SidebarButtonTypeEnum.File)"
        role="button"
        tabindex="3">
        <orbit-fa-icon class="sidebar-icon-only-file" [iconName]="fileIcon" />
      </div> -->
    }
  </div>
  @if (isDraggable()) {
    <div cdkDragHandle class="icons-middle">
      <orbit-fa-icon class="grab-icon" [iconName]="gripVertical" data-testid="conversation-sidebar-drag-handle" />
    </div>
  }
  <!-- @if (!isCollapsed()) {
    <div class="icons-bottom">
      <orbit-button
        id="image-button"
        [icon]="imageIcon"
        (onClick)="buttonClick.emit(SidebarButtonTypeEnum.Image)" />
      <orbit-button
        id="video-button"
        [icon]="videoIcon"
        (onClick)="buttonClick.emit(SidebarButtonTypeEnum.Video)" />
      <orbit-button
        id="microphone-button"
        [icon]="microphoneIcon"
        (onClick)="buttonClick.emit(SidebarButtonTypeEnum.Speak)" />
      <orbit-button
        id="phone-button"
        [icon]="phoneIcon"
        (onClick)="buttonClick.emit(SidebarButtonTypeEnum.Call)" />
    </div>
  } -->
</div>
